import { useCallback, useRef, useEffect } from 'react';

export function useConfirmUnsaved(): [() => void, () => void] {
  const _dirty = useRef<boolean>(false);

  useEffect(() => {
    const handleBeforeUnload = (event: Event) => {
      if (_dirty.current === true) {
        event.preventDefault();
        event.returnValue = false;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [_dirty]);

  // Stable identities, so callers can list these in effect dependencies
  // without the effect re-running every render.
  const clean = useCallback(() => {
    _dirty.current = false;
  }, []);

  const dirty = useCallback(() => {
    _dirty.current = true;
  }, []);

  return [clean, dirty];
}
